<template>
    <v-layout column>
        <v-form ref="form" class="user-profile-form" v-model="valid" lazy-validation>

            <UserForm :customer=customer :newUser=newUser :username=username
                      :setLoadedDefinitions="setLoadedDefinitions"></UserForm>

            <v-spacer class="my-1"></v-spacer>

            <v-flex xs12>
                <div class="text-xs-center">
                    <v-btn
                            :disabled=!isEnabled
                            @click="verifyBeforeSubmit"
                            class="primary"
                            large
                    >
                        {{ $vuetify.t('$vuetify.save') }}
                        <v-icon right small>fal fa-angle-double-right</v-icon>
                    </v-btn>
                </div>
                <v-spacer class="my-2"></v-spacer>
                <div class="text-xs-center">
                    <v-btn
                            flat
                            @click="changePassword"
                    >
                        <v-icon left small>fal fa-key</v-icon>
                        {{ $vuetify.t('$vuetify.authentication.password_change') }}
                    </v-btn>
                    <!--<v-btn @click="clear">Limpar</v-btn>-->
                </div>
            </v-flex>
            <v-dialog v-model="confirmationDialog" width="600px">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ $vuetify.t('$vuetify.alert') }}</span>
                    </v-card-title>
                    <v-card-text>
                        <p>A rejeição do consentimento de registo de dados pessoais implicará a remoção de todas as
                            informações pessoais guardadas em sistema.</p>
                        <p>Os seus dados serão eliminados dentro de 30 dias</p>
                        <p>Confirma o processo de limpeza e o não consentimento de registo dos dados pessoais?</p>
                        <br>
                        <p><b>Esta operação não poderá ser revertida!</b></p>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" flat="flat" @click="disagree">{{ $vuetify.t('$vuetify.confirm') }}</v-btn>
                        <v-btn color="primary" flat="flat" @click="cancel">{{ $vuetify.t('$vuetify.cancel') }}</v-btn>
                    </v-card-actions>
                </v-card>

            </v-dialog>
        </v-form>
    </v-layout>
</template>

<script>
    import {userService} from '../../_services'
    import UserForm from '../../components/UserForm.vue';
    import {getErrorMessage, recaptchaHelper} from "../../_helpers";

    export default {
        name: "User",
        components: {UserForm},
        data: () => ({
            customer: {},
            valid: true,
            loadedProfileDefinitions: false,
            loadedGenericDefinitions: false,
            username: null,
            user: null,
            newUser: false,
            confirmationDialog: false,
        }),
        watch: {
            menu(val) {
                val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
            }
        },

        methods: {
            save(date) {
                this.$refs.menu.save(date)
            },
            disagree() {
                this.customer.gdpr_agreement = 0;
                // this.customer.send_1 = 0;
                // this.customer.send_2 = 0;
                // this.customer.send_6 = 0;
                this.confirmationDialog = false;
                this.submit();
            },
            cancel() {
                this.customer.gdpr_agreement = 1;
                // this.customer.send_1 = 1;
                // this.customer.send_2 = 1;
                // this.customer.send_6 = 1;
                this.confirmationDialog = false;
                this.submit();
            },
            verifyBeforeSubmit() {
                //modified @daniel.silva - show conformation dialog every time that gdpr_agreement is not accepted
                //if (this.customer.gdpr_agreement === 0 && this.user.mandatoryValidateProfile === 0) {
                if (this.customer.gdpr_agreement === 0) {
                    this.confirmationDialog = true;
                } else {
                    this.submit();
                }
            },
            /**
             * The UserForm (child component) on its mounted section, has to load the profile's configuration.
             * Only after the load is finished, the 'Save' button can be displayed as enabled.
             *
             * Therefore, it is the child component which is responsible to update the flags 'loadedProfileDefinitions'
             * and 'loadedGenericDefinitions' which control the 'Save' button through the 'isEnabled' function.
             * The child component updates the parent's properties using this function.
             * */
            setLoadedDefinitions(context, value) {
                if (context === "profile_definitions") {
                    this.loadedProfileDefinitions = value;
                } else if (context === "generic_definitions") {
                    this.loadedGenericDefinitions = value;
                }
            },
            submit() {
                if (this.$refs.form.validate()) {

                    // 1 - setting the Loading Layer
                    this.$store.dispatch("loader/setLoading", true);

                    // 2 - if it is a new user, the profile does not include the phone number;
                    //  this data is given by the username set on the store and mounted here
                    // let telephone = null;
                    // if (this.newUser) {
                    //     telephone = this.username;
                    // }

                    // 3 - defining the object which will be used by the setProfile function of the userService;
                    let obj = {
                        "name": this.customer.name,
                        "birth_date": this.customer.birth_date,
                        "email_address": this.customer.email_address ? this.customer.email_address.trim() : null,
                        "telephone": this.customer.telephone,
                        "tax_number": this.customer.tax_number,
                        "gender": this.customer.gender ? this.customer.gender.value : null,
                        "send_1": this.customer.send_1 ? 1 : 0,
                        "send_2": this.customer.send_2 ? 1 : 0,
                        "send_3": this.customer.send_3 ? 1 : 0,
                        "send_4": this.customer.send_4 ? 1 : 0,
                        "send_5": this.customer.send_5 ? 1 : 0,
                        "send_6": this.customer.send_6 ? 1 : 0,
                        "send_7": this.customer.send_7 ? 1 : 0,
                        "gdpr_agreement": this.customer.gdpr_agreement ? 1 : 0,
                        "favourite_store": this.customer.favourite_store ? this.customer.favourite_store.value : null,
                    };

                    if (this.newUser) {
                        obj.username = this.username
                    }

                    this.$log.debug("User Profile | Before Set User, validate profile = " + this.$store.state.authentication.user.mandatoryValidateProfile);

                    // 4 - using the setProfile function of the userService;
                    //  this service fills in the user's information and in case it's a new user,
                    //      (1) defines the user and customer registers,
                    //      (2) defines a password to the user,
                    //      (3) sends an sms to the user containing the password
                    // All this is made using the API method set_customer_data
                    // Having a success answer from the service:
                    //  4.1 if it is not a new user -> redirect to the Home Page
                    //  4.2 if it is a new user -> redirect to the Password Interface
                    recaptchaHelper('editUser', this).then((token) => {
                            obj.recaptcha_token = token;
                            userService.setProfile(obj).then(result => {
                                    this.$store.dispatch('authentication/setValidateProfile', result.mandatory_validate_profile);

                                    this.username = this.$store.state.authentication.user.username;

                                    if (!this.customer.gdpr_agreement) {
                                        this.$store.dispatch("alert/success", this.$vuetify.t('$vuetify.gdpr_agreement_revoke'));
                                        this.$store.dispatch('authentication/logout');
                                        this.$router.push({name: "login"});
                                    } else {
                                        this.$store.dispatch("alert/success", this.$vuetify.t('$vuetify.user_profile_updated_success'));
                                        if (!this.newUser) {
                                            this.$log.debug("User Profile | Redirect Existing User for the Home Page");
                                            this.$router.push({name: "home"});
                                        } else {
                                            this.$log.debug("User Profile | Redirect New User for the Password Page");
                                            this.$router.push({name: 'login-auth', params: {status: "newUser"}});
                                        }
                                    }

                                    // 5 - removing the Loading Layer
                                    this.$store.dispatch("loader/setLoading", false);
                                },
                                error => {
                                    getErrorMessage(error, 'Edit User', this);
                                });
                        },
                        error => {
                            getErrorMessage(error, 'Edit User Recaptcha', this);
                        });
                }
            },
            clear() {
                this.$refs.form.reset()
            },
            changePassword() {
                this.$router.push({name: "user-change-password"});
            }
        },
        computed: {
            /**
             * The UserForm on its mounted section, has to load the profile's configuration.
             * Only after the load is finished, the 'Save' button can be displayed as enabled.
             *
             * The two flags validated on the following lines,
             *  are the flags updated by the functions on the UserForm mounted section,
             *  through the 'setLoadedDefinitions' method.
             * @returns {boolean}
             */
            isEnabled() {
                //@modified ana.castro 2019.09.13 save_button_profile disabled sometimes
                // return this.loadedProfileDefinitions && this.loadedGenericDefinitions;
                return this.loadedProfileDefinitions;
            }
        },
        mounted() {
            // Called after the instance has been mounted:
            //  1 - getting from the store the username given on the 1st step (view LoginUsername);
            //      which was set on the authentication module by the setLoginUsername mutation
            //  1.1 if the fetched variable is an object -> existing user. We can get the customer object
            //  1.2 if the fetched variable is not an object and if it exists its because it is a new user
            //      and the variable only has an username. This means this view is being called for a new user (coming from the login page);
            this.user = this.$store.state.authentication.user;
            this.username = this.$store.state.authentication.user.username;

            if (typeof this.user === 'object' && this.username !== null) {
                userService.get().then(data => this.customer = data);
            } else {
                this.newUser = true;
            }

            //  2 - if the user accessed this view directly, a information we can obtain by analyzing the username value,
            //      the user should be redirected to the 1st step (view LoginUsername);
            if (this.username === undefined) {
                this.$router.push({name: "login"});
            }
        },
    }
</script>

<style scoped>

</style>